<div class="modal-header">
  <h4 class="modal-title">{{ "sphere.account.cancel_membership" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="cancelLoader"></myp-inline-loader>

  @if (!loading) {
    <div>
      @if (!softCanceling) {
        @if (userService.subDetails.subscription.schedule_subscription_id && userService.subDetails.subscription.bundle_time) {
          {{ "stripe.cancel_notice_bundled_time" | translate: { planEnd: userService.subDetails?.upcoming_invoice_preview.next_payment_attempt * 1000 | date: "MMMM Do, YYYY" } }}
        }
        @if (userService.subDetails.subscription_status == "monthly_active_coupon") {
          {{ "stripe.cancel_notice_monthly_active_coupon" | translate: { discountEnd: userService.subDetails.stripe_subscription.discount.end * 1000 | date: "MMMM Do, YYYY" } }}
        }
        @if (userService.subDetails.subscription.provider_subscription_id && !userService.subDetails.subscription.bundle_time) {
          <div [innerHTML]="'stripe.cancel_notice_no_bundled_time' | translate"></div>
        }
      }
      @if (softCanceling) {
        <div class="form-group col-md-12">
          <label class="control-label">{{ "stripe.sorry_to_see_you_go" | translate }}</label>
          <select class="form-control" [(ngModel)]="reasonCode">
            <option value="-1">Make a selection...</option>
            @for (code of reasonCodes; track code) {
              <option [ngValue]="code.code">{{ code.title }}</option>
            }
          </select>
        </div>
        <div class="form-group col-md-12">
          <label class="control-label">Add more details</label>
          <textarea name="cancel_reason" id="cancel_reason" [(ngModel)]="cancelReason" class="form-control">{{ cancelReason }}</textarea>
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  @if (!softCanceling) {
    <button type="button" [disabled]="loading" class="btn btn-danger" (click)="softCanceling = true">
      <span>{{ "sphere.account.do_cancel" | translate }}</span>
    </button>
  }
  @if (softCanceling) {
    <button type="button" [disabled]="loading" class="btn btn-danger" (click)="cancel()">
      <span>{{ "sphere.account.do_cancel" | translate }}</span>
    </button>
  }
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "sphere.account.nevermind_cancel" | translate }}</button>
</div>
